<div class="page-content page-content-after-header task-container">
  <div class="row">
    <div class="col-6"></div>
    <div class="col-6 right task-sort">
      <div ngbDropdown #theDropdown="ngbDropdown" (openChange)="toggleSort()" placement="bottom-end">
        <input readonly="readonly" class="task-dropdown" [ngClass]="sortOpened ? 'opened' : ''" placeholder="Sort By"
          autocomplete="off" autocorrect="off" ngbDropdownToggle />
        <div ngbDropdownMenu class="pre-scrollable">
          <button (click)="onSortChange(sortType);theDropdown.close();" *ngFor="let sortType of sortTypes"
            id="{{ sortType }}" ngbDropdownItem>{{ sortType }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row task-grid-row outline margin-bottom" *ngIf="endOfDayTask">
    <div class="col-2 task-type" [ngClass]="taskService.getTaskClass(endOfDayTask)">{{ endOfDayTask.taskType }}</div>
    <div class="col-8 low-padding">Please confirm that your stock inventory is updated, transport are aware of any
      non-runners, outstanding confirm calls have been attempted, and keys/documents will be removed from the secured
      branch.</div>
    <div class="col-2"><button (click)="completeEndOfDayTask(endOfDayTask.taskId)" class="end-of-day-task-button button_green">Complete
        <img alt="" class="resize-image" src="../../../assets/icons/outlined/tick.png"></button></div>
  </div>
  <div class="row task-grid-row-trade outline margin-bottom" *ngIf="readyToTradeTask">
    <div class="col-2 task-type" [ngClass]="taskService.getTaskClass(readyToTradeTask)">{{ readyToTradeTask.taskType }}</div>
    <div class="col-7 low-padding-trade">Is the branch clean and tidy? Please ensure there is at least one spare water bottle
      available, and confirm that you are wearing the complete WBAC uniform.</div>
    <div class="col-3">
      <div class="button-group">
        <button class="edit-button " type="button" (click)="editReadyToTradeTaskMessage()"
          [ngClass]="{ 'button_blue': isComplete }">
          <img alt="" class="resize-image" [src]="isComplete ? completeIconPath : editIconPath">
        </button>
        <button (click)="completeReadyToTradeTask(readyToTradeTask.taskId)" class="ready-to-trade-task-button button_green">Complete <img alt=""
            class="resize-image-trade" src="../../../assets/icons/outlined/tick.png"></button>
      </div>
    </div>
  </div>
  <div class="row task-grid-header">
    <div class="col-1" *ngIf="isEditing">Select All</div>
    <div class="col-2">Task Type</div>
    <div class="col-3">Customer's Name</div>
    <div class="col-2">Date & Time of Appointment</div>
    <div [ngClass]="isEditing ? 'col-2' : 'col-3'">VRM</div>
    <div class="col-2">Branch</div>
  </div>
  <div class="row task-grid-row" *ngFor="let task of pagedTasks; let i = index" (click)="actionTask(task)">
    <div class="col-1" *ngIf="isEditing"></div>
    <div class="col-2 task-type" [ngClass]="taskService.getTaskClass(task)">{{ task.taskType }}</div>
    <div class="col-3 obfuscated-playback">{{ task.customerName }}</div>
    <div class="col-2">{{ task.appointmentDate | date: "dd/MM/yyyy HH:mm" }}</div>
    <div [ngClass]="isEditing ? 'col-2' : 'col-3'">{{ task.vrm }}</div>
    <div class="col-2">{{ task.branch }}</div>
  </div>
  <app-pager [pageCount]="pageCount" [currentPage]="currentPage"></app-pager>
</div>